//custom quote widget definition
class CustomQuoteWidget extends HTMLElement {
    constructor() {
        super();
        this.widgetMode = this.dataset.mode;

        this.mainProductSection = document.querySelector("section.main-product");

        //get quote list from storage
        this.quoteStorage = localStorage.getItem("qwList");
        this.overlayContainer = this.querySelector(".custom-quote-widget__overlay--container");
        this.emptyListMessage = this.querySelector(".custom-quote-widget__overlay--product-list--empty-message");
        this.quoteBody = this.querySelector(".custom-quote-widget__overlay--body");
        this.loader = this.querySelector(".custom-quote-widget__loader");
        //product list container
        this.productListContainer = this.querySelector(".custom-quote-widget__overlay--product-list--container");
        if (this.widgetMode === "widget") {
            //label
            this.label = this.querySelector(".custom-quote-widget__label");
        }
        //header icon
        this.quoteIcon = document.querySelector(".qw-icon-quote");

        //if quote exist retrieve data and convert to js, otherwise create empty array
        if (this.quoteStorage?.length > 2) {
            this.quoteList = JSON.parse(this.quoteStorage);
        } else {
            this.quoteList = [];
        }
        this.refreshProductList();
        //overlay
        this.overlay = this.querySelector(".custom-quote-widget__overlay");
        //closing overlay button
        this.closeOverlayButton = this.querySelector("button.custom-quote-widget__overlay--close");
        //continue shopping button
        this.continueShoppingButtons = this.querySelectorAll(".custom-quote-widget__overlay--continue");

        this.quoteFormSection = this.querySelector(".custom-quote-widget__overlay--contact-form");
        this.quoteForm = this.querySelector("form#QuoteRequest");

        this.submitButton = this.querySelector('form#QuoteRequest button[type="submit"]');

        this.submitButton.addEventListener("click", (evt) => {
            evt.preventDefault();

            this.querySelectorAll(".form__error-list, .form-status-list").forEach((el) => {
                el.style.display = "none";
            });

            this.errorCounter = 0;
            this.highlightFormErrors()

            if (this.errorCounter === 0) {
                this.generateRequestDataAndSubmitQuote();
            } else {
                setTimeout(() => this.quoteForm.scrollIntoView({
                    behavior: 'smooth'
                }))
            }
        });

        this.userInputs = {
            'contact[Name]': this.querySelector('input[name="contact[Name]"]'),
            'contact[email]': this.querySelector('input[name="contact[email]"]'),
            'contact[Phone number]': this.querySelector('input[name="contact[Phone number]"]'),
            'contact[Message]': this.querySelector('textarea[name="contact[Message]"]')
        };

        if (this.widgetMode === "widget") {
            if (this.label) {
                //listening to label, on click trigger overlay opening method
                this.label.addEventListener("click", (evt) => {
                    evt.preventDefault();

                    this.openOverlay();
                });
            }
            //listening to closing overlay button, on click trigger closing method
            this.closeOverlayButton.addEventListener("click", (evt) => {
                evt.preventDefault();

                this.closeOverlay();
            });
            //listening to continue shopping button, on click trigger closing method
            this.continueShoppingButtons.forEach(continueShoppingButton => {
                continueShoppingButton.addEventListener("click", (evt) => {
                    evt.preventDefault();

                    this.closeOverlay();
                });
            })

            if (
                (window.location.href.includes("#QuoteRequest") ||
                    (this.querySelector(".form-status") && !this.querySelector(".form-status").closest('.form__message.qw-remove-display'))) &&
                !window.location.href.includes("challenge")
            ) {

                this.populateUserInputsFormFromUrl(window.location.href)
                this.openOverlay(this.quoteFormSection);
            }

            //if mimeeq app is loaded
            document.addEventListener("mimeeq-app-loaded", () => {

                //set button label
                mimeeqCustomMessages['historymodule.panelmenufooter.finish'] = 'Add To Quote Request'
                mimeeqCustomMessages['header3d.finish'] = 'Add To Quote Request'


                document.querySelector('#modal-root').style.transition = 'all 0.3s ease-in-out';

                this.mimeeqEmbed = document.querySelector('mmq-embed')
                this.mimeeqEmbed.basket = false

                document.addEventListener('mimeeq-show-summary', (e) => {
                    e.preventDefault()
                    e.stopImmediatePropagation()

                    const payload = e.detail
                    this.addMimeeqProductToQuote(payload);
                }, true);
                document.addEventListener('mimeeq-show-modular-summary', (e) => {

                    document.querySelector('#modal-root').style.opacity = '0';
                    document.querySelector('#modal-root').style.pointerEvents = 'none';
                }, true);

            });
        }
    }

    //function to close overlay
    closeOverlay() {
        this.overlay.classList.remove("qw-show");
    }

    //function to open overlay
    openOverlay(focusedElement = null) {
        this.overlay.classList.add("qw-show");
        if (focusedElement) {
            setTimeout(() => focusedElement.scrollIntoView())
        }
    }

    //save quote to storage
    saveQuote() {
        localStorage.setItem("qwList", JSON.stringify(this.quoteList));
    }

    //check if a product is in quote list, if product is in list return its object from the quote list, otherwise return false
    productInQuoteList(productData) {
        if (this.quoteList.length) {
            for (let i = 0; i < this.quoteList.length; i++) {
                if (this.quoteList[i].uniqueId === productData.uniqueId) {
                    return this.quoteList[i];
                }
            }

            return false;
        } else {
            return false;
        }
    }

    //create a new product html element for product list given image, title and quantity
    createProductHTMLElement(productObj) {
        function createElementWithClass(tag, classes = "") {
            let newEl = document.createElement(tag);
            newEl.classList.add(classes);
            return newEl;
        }

        let mainContainer = createElementWithClass("div", "custom-quote-widget__overlay--product-list--product");

        mainContainer.data = productObj;

        //set image element depending on product type
        let productImageEl;
        let productUrl;
        let variantTitleIsValid
        if (productObj.type === "mimeeq") {
            productUrl = productObj.url
            productImageEl = `<a href="${productUrl}" class="custom-quote-widget__overlay--product-list--product--image--container"><div class="custom-quote-widget__overlay--product-list--product--image"
                style="background-image: url('${productObj.imageURI}')"></div></a>`;
        } else {
            productUrl = productObj.variantUrl ? productObj.variantUrl : productObj.url
            productImageEl = `<a href="${productUrl}" class="custom-quote-widget__overlay--product-list--product--image--container"><div class="custom-quote-widget__overlay--product-list--product--image">
            <img src="${productObj.variantImageUrl ? productObj.variantImageUrl : productObj.imageUrl}" alt="${productObj.title}">
            </div></a>`;
            variantTitleIsValid = productObj.variantTitle && productObj.variantTitle !== 'Default Title'
        }

        mainContainer.innerHTML = `${productImageEl}
            <div class="custom-quote-widget__overlay--product-list--product--box">
                <div class="custom-quote-widget__overlay--product-list--product--title">
                <a href="${productUrl}">
                ${productObj.title}</a>
                </div>
                ${variantTitleIsValid ?
            `<div class="custom-quote-widget__overlay--product-list--variant-title">
                    ${productObj.variantTitle}
                </div>` : ''}
                <div class="custom-quote-widget__overlay--product-list--product--quantity">
                    <div class="custom-quote-widget__overlay--product-list--product--quantity--text">
                    ${this.productListContainer.dataset.quantityText}
                    </div>
                    <div class="quantity-selector">
                       <custom-minimum-order-widget data-moq="${productObj.moq}">
                            <div class="custom-minimum-order-widget__container">
                                Please note the minimum order quantity for this product is <span class="moq-string">${productObj.moq}</span>. If you need less, please reach out as we may be able to accommodate
                            </div>
                       </custom-minimum-order-widget>
                      <button type="button" class="quantity-selector__button quantity__button minus" name="minus" aria-label="Decrease quantity"><svg role="presentation" focusable="false" width="10" height="2" class="icon icon-minus" viewBox="0 0 10 2">
                          <path d="M0 0H10V2H0V0Z" fill="currentColor"></path>
                      </svg></button>
                              <input id="product-form-8128434045192-template--17477358059784__main-quantity" type="text" is="quantity-input" min="${productObj.moq}" inputmode="numeric" class="quantity-selector__input" name="quantity" form="product-form-8128434045192-template--17477358059784__main" size="2" value="${productObj.quantity}" autocomplete="off">
                              <button type="button" class="quantity-selector__button quantity__button" aria-label="Increase quantity" name="plus"><svg role="presentation" focusable="false" stroke-width="2" width="10" height="10" class="icon icon-plus" viewBox="0 0 12 12">
                          <path d="M6 0V12" fill="none" stroke="currentColor"></path>
                          <path d="M0 6L12 6" fill="none" stroke="currentColor"></path>
                      </svg>
                      </button>
                    </div>
                </div>
                <div class="custom-quote-widget__overlay--product-list--product--remove">
                ${this.productListContainer.dataset.removeText}
                </div>
            </div>`;

        //listen for remove button
        mainContainer
            .querySelector(".custom-quote-widget__overlay--product-list--product--remove")
            .addEventListener("click", (evt) => {
                evt.preventDefault();
                this.removeProductFromStorage(productObj);
            });
        //listen for plus button
        mainContainer
            .querySelector('.quantity__button[name="plus"]')
            .addEventListener("click", (evt) => {
                evt.preventDefault();
                this.addProductQuantity(productObj, 1);

                this.saveQuote();

                this.refreshProductList();
            });
        //listen for minus button
        mainContainer
            .querySelector('.quantity__button[name="minus"]')
            .addEventListener("click", (evt) => {
                evt.preventDefault();

                if (this.productInQuoteList(productObj).quantity > 1) {
                    this.removeProductQuantity(productObj, 1);

                    this.saveQuote();

                    this.refreshProductList();
                }
            });

        return mainContainer;
    }

    //generate a product element and append it to the list
    appendProductElement(productObj) {
        this.productListContainer.append(this.createProductHTMLElement(productObj));
    }

    /*
          //generate all product elements and append them to the list
          generateFullProductsList() {
              this.quoteList.forEach((productData) => {
                  this.appendProductElement(productData)
              })
          }*/

    //add product to quote list
    addProductToQuote(productData) {
        if (this.productInQuoteList(productData)) {
            this.addProductQuantity(productData, productData.quantity);
        } else {
            this.quoteList.push(productData);
        }
        this.saveQuote();
    }

    //remove product from quote list array and storage
    removeProductFromStorage(productData) {
        let productIndex = this.quoteList.indexOf(this.productInQuoteList(productData));
        this.quoteList.splice(productIndex, 1);
        this.saveQuote();
        this.refreshProductList();
    }

    addProductQuantity(productData, addedQuantity) {
        this.productInQuoteList(productData).quantity += addedQuantity;
    }

    removeProductQuantity(productData, removedQuantity) {
        this.productInQuoteList(productData).quantity -= removedQuantity;
    }

    //refresh product list
    refreshProductList() {
        const allProductElements = this.productListContainer.querySelectorAll(".custom-quote-widget__overlay--product-list--product");
        const allProductElementsUniqueIds = () => {
            let allIds = [];
            this.productListContainer
                .querySelectorAll(".custom-quote-widget__overlay--product-list--product")
                .forEach((productEl) => {
                    allIds.push(productEl.data.uniqueId);
                });
            return allIds;
        };
        const allQuoteListUniqueIds = () => {
            let allIds = [];
            this.quoteList.forEach((productObj) => {
                allIds.push(productObj.uniqueId);
            });
            return allIds;
        };

        //if quote list is shorter than rendered, a product has to be removed
        if (this.quoteList.length < allProductElements.length) {
            allProductElements.forEach((productEl) => {
                if (!allQuoteListUniqueIds().includes(productEl.data.uniqueId)) {
                    this.productListContainer.removeChild(productEl);
                }
            });
        } else {
            //if quote list is longer or has the same length add quantity or append new product
            this.quoteList.forEach((productData) => {
                if (allProductElementsUniqueIds().includes(productData.uniqueId)) {
                    allProductElements.forEach((productEl) => {
                        if (productEl.data.uniqueId === productData.uniqueId) {
                            productEl.querySelector("input").value = productEl.data.quantity;
                        }
                    });
                } else {
                    this.appendProductElement(productData);
                }
            });
        }
        if (this.quoteList.length) {
            this.hideEmptyListMessage();
        } else {
            this.showEmptyListMessage();
        }
    }

    //show empty list message
    showEmptyListMessage() {
        this.emptyListMessage.classList.remove("qw-remove-display");
        this.quoteBody.classList.add("qw-remove-display");
        if (this.widgetMode === "widget") {
            this.overlayContainer.classList.remove("active");

            if (this.label) {
                //hide count from widget label
                this.label
                    .querySelector(".custom-quote-widget__label--active-products-text")
                    .classList.add("qw-remove-display");
            }
        }
        //update icon count
        this.quoteIcon?.style.setProperty("--icon-quote-count", "0");
        this.quoteIcon?.classList.add('no-count')
    }

    //hide empty list message
    hideEmptyListMessage() {
        this.emptyListMessage.classList.add("qw-remove-display");
        this.quoteBody.classList.remove("qw-remove-display");
        if (this.widgetMode === "widget") {
            this.overlayContainer.classList.add("active");
            if (this.label) {
                //update widget label
                this.label
                    .querySelector(".custom-quote-widget__label--active-products-text")
                    .classList.remove("qw-remove-display");
                this.label.querySelector(".custom-quote-widget__label--active-products-number").innerText = this.quoteList.length;
            }
        }
        //update icon count
        this.quoteIcon?.style.setProperty(
            "--icon-quote-count",
            this.quoteList.length
        );
        this.quoteIcon?.classList.remove('no-count')
    }

    generateRequestDataAndSubmitQuote() {
        this.quoteBody.classList.add("qw-remove-display");
        this.overlayContainer.classList.remove("active");

        this.loader.classList.remove("qw-remove-display");

        let productsTextarea = this.querySelector("textarea#QuoteRequest-products");
        productsTextarea.value = "";
        let userIpText = this.querySelector("input#QuoteRequest-user_ip");
        userIpText.value = "";
        let userCountryText = this.querySelector("input#QuoteRequest-country");
        userCountryText.value = "";

        //generates and returns product text given product data
        function generateProductText(productData) {
            return `\n${productData.title}\n${productData.variantTitle && productData.variantTitle !== 'Default Title' ? 'variant: ' + productData.variantTitle + '\n' : ''}type: ${productData.type}\nurl: ${productData.variantUrl ? productData.variantUrl : productData.url}\nid: ${productData.productId}\nquantity: ${productData.quantity}\n\n`;
        }

        this.quoteList.forEach((productData) => {
            productsTextarea.value += generateProductText(productData);
        });
        //get user IP and send
        let that = this;
        let request = new XMLHttpRequest();
        request.open("GET", "https://api.db-ip.com/v2/free/self", true);

        request.onload = function () {
            if (request.status >= 200 && request.status < 400) {
                // Success!
                let data = JSON.parse(request.responseText);
                userCountryText.value = data.countryName;
                userIpText.value = data.ipAddress;
            } else {
                userCountryText.value = "Not provided";
                userIpText.value = "Not provided";
            }
            that.quoteForm.submit();
        };
        request.send();
    }

    async addMimeeqProductToQuote(payload) {

        const calculatedConfigurationCode = payload.isModular ? payload.elements.map(el => el.configurationCode).join('') : payload.configurationCode

        let currentProduct = {
            type: "mimeeq",
            productId: this.mainProductSection.dataset.productId,
            title: this.mainProductSection.dataset.productTitle,
            imageURI: payload.isModular ? payload.image : '',
            configurationCode: calculatedConfigurationCode,
            quantity: payload.qty,
            url: window.location.href + (payload.isModular ? `&shortCode=${payload.shortCode}` : ''),
            uniqueId: this.mainProductSection.dataset.productId + calculatedConfigurationCode,
            moq: Number(this.mainProductSection.dataset.moq) || 1
        };


        //if quantity is less than moq, update value
        if (currentProduct.quantity < currentProduct.moq) currentProduct.quantity = currentProduct.moq

        if (!currentProduct.imageURI) {
            // Create a promise that resolves after 2 seconds
            let timeoutPromise = new Promise((resolve) => setTimeout(resolve, 2000));

            // Race the timeoutPromise against the takeScreenshot promise
            await Promise.race([window.mimeeqApp.utils.takeScreenshot(
                "jpg",
                500,
                '#F4F4F4',
                null,
                true,
                true
            ).then((base64Img) => {
                currentProduct.imageURI = base64Img;
            }).catch(e => {
                console.warn('the error:', e);
                return null;
            }), timeoutPromise]);

            if (!currentProduct.imageURI) {
                const imgURL = document.querySelector('mmq-variant-ui img#mmq-variant-images-current').src

                await this.imageToURI(imgURL).then(dataUrl => {
                    currentProduct.imageURI = dataUrl
                })
            }
        }

        this.addProductToQuote(currentProduct);

        this.refreshProductList();

        this.mimeeqEmbed.hide()

        document.querySelector('#modal-root').style.opacity = '1';
        document.querySelector('#modal-root').style.pointerEvents = 'auto';

        this.openOverlay();
    }

    imageToURI(url) {
        return fetch(url)
            .then(response => response.blob())
            .then(blob => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onloadend = () => resolve(reader.result)
                reader.onerror = reject
                reader.readAsDataURL(blob)
            }))
    }

    populateUserInputsFormFromUrl(url) {
        // Create a URL object from the provided string
        const urlObj = new URL(url);

        // Iterate over the userInputs object and populate the form fields
        for (const param in this.userInputs) {
            if (this.userInputs.hasOwnProperty(param)) {
                // Get the value from the URL
                const value = urlObj.searchParams.get(param);

                // If the value exists and the input element is found, set the value
                if (value && this.userInputs[param]) {
                    this.userInputs[param].value = decodeURIComponent(value);
                }
            }
        }

        // Remove the query parameters from the URL
        /*const newUrl = window.location.href.split('?')[0];
        window.history.replaceState({path: newUrl}, '', newUrl);*/

    }

    highlightFormErrors() {
        let allRequiredInputs = this.quoteForm.querySelectorAll("input[required]");
        allRequiredInputs.forEach((input) => {
            const phonePattern = /^[0-9\-()+\s]*$/;
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (
                !input.value.length ||
                (input.type === 'tel' && !phonePattern.test(input.value)) ||
                (input.type === 'email' && !emailPattern.test(input.value))
            ) {
                input.parentElement.querySelector(".contact__field-error").style.display = "block";
                this.errorCounter++;
            } else {
                input.parentElement.querySelector(".contact__field-error").style.display = "none";
            }
        });
    }


}

customElements.define("custom-quote-widget", CustomQuoteWidget);

class CustomQuoteWidgetAddButton extends HTMLElement {
    constructor() {
        super();

        const allForms = [...document.forms]
        this.productForm = allForms.find(form => form.action.includes('cart/add'))
        if (this.productForm) {
            this.listenForVariantChanges()
        }

        //get main quote widget
        this.quoteMainWidget = document.querySelector("custom-quote-widget");
        //listening to add to quote button, on click trigger add to quote and open overlay
        this.addEventListener("click", (evt) => {
            evt.preventDefault();
            //create current product object
            this.currentProduct = {
                type: this.dataset.productType,
                productId: this.dataset.productId,
                variantId: this.dataset.variantId,
                title: this.dataset.productTitle,
                variantTitle: this.dataset.variantTitle,
                imageUrl: this.dataset.productImageUrl,
                variantImageUrl: this.dataset.variantImageUrl,
                quantity: Number(document.querySelector("quantity-selector input").value),
                url: this.dataset.productUrl,
                variantUrl: this.dataset.productUrl + `?variant=${this.dataset.variantId}`,
                uniqueId: this.dataset.variantId,
                moq: Number(this.dataset.moq) || 0
            };

            //if quantity is less than moq, update value
            if (this.currentProduct.quantity < this.currentProduct.moq) this.currentProduct.quantity = this.currentProduct.moq

            this.quoteMainWidget.addProductToQuote(this.currentProduct);
            this.quoteMainWidget.refreshProductList();
            this.quoteMainWidget.openOverlay();
        });
    }

    listenForVariantChanges() {
        this._onVariantChangedListener = this._onVariantChanged.bind(this);
        this.productForm?.addEventListener("variant:change", this._onVariantChangedListener);
    }

    _onVariantChanged(evt) {
        const variant = evt.detail.variant

        const variantId = variant.id
        const variantImageUrl = variant.featured_image?.src
        const variantTitle = variant.title


        if (variantId) {
            this.setAttribute('data-variant-id', `${variantId}`)
            this.setAttribute('data-variant-image-url', `${variantImageUrl? variantImageUrl: ''}`)
            this.setAttribute('data-variant-title', `${variantTitle}`)
        }
    }
}

customElements.define("custom-quote-widget-add-button", CustomQuoteWidgetAddButton);